import { useState } from "react";
import { toast } from "react-toastify";
import { Button, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import Config from "../../Config/TemplateConfig";
import { Href } from "../../Constants/Constants";
import { SettingSidebarType } from "../../Types/MessengerType";

const SettingSidebar: React.FC<SettingSidebarType> = ({ setCustomizer }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  
  const handleThemeCopy = async () => {
    const clipBoardString = JSON.stringify(Config, null, 2);
    await navigator.clipboard.writeText(clipBoardString);
    toast.success("Code Copied to clipboard !", { position: "bottom-right" });
  };
  return (
    <div className="template-title">
      <div className="d-flex">
        <div>
          <h2>{"Customizer"}</h2>
          <h4>{"Real Time Customize"}</h4>
          <Button color="primary" className="plus-popup mt-2 btn-sm" onClick={() => setModal(!modal)}>
            {"Configuration"}
          </Button>
        </div>
        <div className="flex-grow-1">
          <a className="icon-btn btn-outline-light button-effect pull-right cog-close" href={Href} onClick={setCustomizer}>
            <i className="fa fa-close" />
          </a>
        </div>
        <Modal isOpen={modal} toggle={toggle} className="modal-body configuration-modal add-popup" centered={true}>
          <ModalHeader toggle={toggle}>{"Modal Title"}</ModalHeader>
          <ModalBody>
            <Container fluid={true} className="bd-example-row">
              <Row>
                <p>{"To replace our design with your desired Template. Please do configuration as mention"} </p>
                <p>
                  <b> {"Path : src > Config > TemplateConfig.tsx"}</b>
                </p>
              </Row>
              {Object.keys(Config).map((key, index) => (
                <h5 className="mb-2" key={index}>
                  <p>
                    <b>{key} :- </b>
                    <span>
                      <b> {Config[key as keyof typeof Config]}</b>
                    </span>
                  </p>
                </h5>
              ))}
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" className="notification btn-sm" onClick={handleThemeCopy}>
              {"CopyText"}
            </Button>
            <Button color="secondary" className="btn-sm" onClick={toggle}>
              {"Cancel"}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default SettingSidebar;
